<template>
  <div
    class="d-flex pa-2 flex-column"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div class="d-flex pa-5 flex-column">
      <h3>{{ merchantTypeId == '1' ? 'Merchant' : 'Sub Merchant' }} Detail</h3>
      <p>
        Informasi detail mengenai
        {{ merchantTypeId == '1' ? 'merchant' : 'sub merchant' }}
      </p>
      <p>{{ data == null ? '' : data.task_type }}</p>
    </div>

    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>

    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        v-if="!isEdit && merchantType == 'Aggregator'"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data QR</h3>
        </div>
      </v-card>
      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Aggregator'"
      >
        <data-detail-row
          :oldValueData="oldValue('qr_type') != false"
          :data="data"
          :label="'Jenis QR'"
          :valueData="data.qr_type"
          :oldData="oldValue('qr_type')"
        />
        <v-row
          style="align-items: center"
          v-show="
            data != null && (data.id_qr_type == '4' || data.id_qr_type == '5')
          "
        >
          <v-col cols="10" sm="4" />
          <v-col cols="2" sm="1" />
          <v-col cols="12" sm="7">
            <v-radio-group
              class="ma-0"
              v-model="notifSticker"
              column
              disabled
              readonly
              dense
            >
              <template v-slot:label>
                <div>
                  Apakah anda membutuhkan <strong>notif transaksi</strong> via
                  API untuk merchant sticker anda?
                </div>
              </template>
              <v-radio value="1">
                <template v-slot:label>
                  <div v-if="oldValue('notif_sticker_status') != false">
                    <div v-if="oldValue('notif_sticker_status') == '1'">
                      Ya <span class="red--text">( before )</span>
                    </div>
                    <div v-if="oldValue('notif_sticker_status') == '0'">
                      Ya <span class="red--text">( after )</span>
                    </div>
                  </div>
                  <div v-else>Ya</div>
                </template>
              </v-radio>
              <v-radio value="0">
                <template v-slot:label>
                  <div v-if="oldValue('notif_sticker_status') != false">
                    <div v-if="oldValue('notif_sticker_status') == '0'">
                      Tidak <span class="red--text">( before )</span>
                    </div>
                    <div v-if="oldValue('notif_sticker_status') == '1'">
                      Tidak <span class="red--text">( after )</span>
                    </div>
                  </div>
                  <div v-else>Tidak</div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </div>
      <v-card
        class="mb-12"
        height="20px"
        :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
        v-if="merchantType == 'Aggregator'"
      >
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>Data PIC</h3>
        </div>
      </v-card>
      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Aggregator'"
      >
        <data-detail-row
          :oldValueData="oldValue('aggre_pic_name') != false"
          :data="data"
          :label="'Nama PIC'"
          :valueData="data.aggre_pic_name"
          :oldData="oldValue('aggre_pic_name')"
        />
        <data-detail-row
          :oldValueData="oldValue('aggre_pic_ktp_no') != false"
          :data="data"
          :label="'Nomor KTP PIC'"
          :valueData="data.aggre_pic_ktp_no"
          :oldData="oldValue('aggre_pic_ktp_no')"
        />
        <data-detail-row
          :oldValueData="oldValue('aggre_pic_jabatan') != false"
          :data="data"
          :label="'Jabatan'"
          :valueData="data.aggre_pic_jabatan"
          :oldData="oldValue('aggre_pic_jabatan')"
        />
        <data-detail-row
          :oldValueData="oldValue('aggre_pic_mobile_phone') != false"
          :data="data"
          :label="'No Handphone'"
          :valueData="data.aggre_pic_mobile_phone"
          :oldData="oldValue('aggre_pic_mobile_phone')"
        />
        <data-detail-row
          :oldValueData="oldValue('aggre_pic_email') != false"
          :data="data"
          :label="'Email'"
          :valueData="data.aggre_pic_email"
          :oldData="oldValue('aggre_pic_email')"
        />
      </div>
      <div
        v-if="
          data != null &&
          data.aggregator_name != null &&
          data.aggregator_name != '' &&
          isAdd
        "
      >
        <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Aggregator</h3>
          </div>
        </v-card>
        <div :style="{ padding: '20px 50px 20px 50px' }">
          <data-detail-row
            :oldValueData="oldValue('aggregator_name') != false"
            :data="data"
            :label="'Nama Aggregator'"
            :valueData="data.aggregator_name"
            :oldData="oldValue('aggregator_name')"
          />
        </div>
      </div>
      <v-card :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3>{{ this.headingInfo }}</h3>
        </div>
      </v-card>

      <!-- ======================================== detail data start -->

      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Merchant' && isEdit && isUpdatePTEN"
      >
        <!-- ============== detail one -->
        <dt-detail-one :data="data" />

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.remark != null"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Remarks</h3>
          </div>
        </v-card>
        <v-card
          v-if="data != null && data.remark != null"
          :style="{ 'box-shadow': '0 0 black' }"
        >
          <remark-row :data="data" />
        </v-card>
        <v-row v-if="!isHistory">
          <v-col cols="12">
            <v-textarea
              v-if="!isInputer"
              outlined
              v-model="remark"
              label="Remarks"
              :error-messages="remarkErrors"
            />
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px">
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="success"
              dark
              :style="{ margin: '2px' }"
              @click="approveItem"
            >
              Approve
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="error"
              dark
              :style="{ margin: '2px' }"
              @click="rejectItem"
            >
              Reject
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer && !isDisabled && !isCPTS"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
              @click="sendbackItem"
            >
              Send Back
            </v-btn>
            <v-btn
              v-if="data != null && !isHistory && isInputer"
              @click="revisiItem"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
            >
              Revisi
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Merchant' && isEdit && !isUpdatePTEN"
      >
        <!-- ============== detail two -->
        <dt-detail-two :data="data" :isHistory="isHistory" />

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.remark != null"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Remarks</h3>
          </div>
        </v-card>
        <v-card
          v-if="data != null && data.remark != null"
          :style="{ 'box-shadow': '0 0 black' }"
        >
          <remark-row :data="data" />
        </v-card>
        <v-row v-if="!isHistory">
          <v-col cols="12">
            <v-textarea
              v-if="!isInputer"
              outlined
              v-model="remark"
              label="Remarks"
              :error-messages="remarkErrors"
            />
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px">
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="success"
              dark
              :style="{ margin: '2px' }"
              @click="approveItem"
            >
              Approve
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="error"
              dark
              :style="{ margin: '2px' }"
              @click="rejectItem"
            >
              Reject
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer && !isDisabled && !isCPTS"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
              @click="sendbackItem"
            >
              Send Back
            </v-btn>
            <v-btn
              v-if="data != null && !isHistory && isInputer"
              @click="revisiItem"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
            >
              Revisi
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Merchant' && !isEdit"
      >
        <!-- ============== detail three -->
        <dt-detail-three :data="data" :isHistory="isHistory" />

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.remark != null"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Remarks</h3>
          </div>
        </v-card>
        <v-card
          v-if="data != null && data.remark != null"
          :style="{ 'box-shadow': '0 0 black' }"
        >
          <remark-row :data="data" />
        </v-card>
        <v-row v-if="!isHistory">
          <v-col cols="12">
            <v-textarea
              v-if="!isInputer"
              outlined
              v-model="remark"
              label="Remarks"
              :error-messages="remarkErrors"
            />
          </v-col>
        </v-row>
        <v-row style="margin-top: 20px">
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="success"
              dark
              :style="{ margin: '2px' }"
              @click="approveItem"
            >
              Approve
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="error"
              dark
              :style="{ margin: '2px' }"
              @click="rejectItem"
            >
              Reject
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer && !isDisabled && !isCPTS"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
              @click="sendbackItem"
            >
              Send Back
            </v-btn>
            <v-btn
              v-if="data != null && !isHistory && isInputer"
              @click="revisiItem"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
            >
              Revisi
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <div
        :style="{ padding: '20px 50px 20px 50px' }"
        v-if="!loading && merchantType == 'Aggregator'"
      >
        <!-- ============== detail four -->
        <dt-detail-four :data="data" />

        <v-card
          class="mb-12"
          height="20px"
          :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }"
          v-if="data != null && data.remark != null"
        >
          <div class="d-flex pa-5 flex-column align-center justify-center">
            <h3>Remarks</h3>
          </div>
        </v-card>
        <v-card
          v-if="data != null && data.remark != null"
          :style="{ 'box-shadow': '0 0 black' }"
        >
          <remark-row :data="data" />
        </v-card>
        <v-row v-if="!isHistory">
          <v-col cols="12">
            <v-textarea
              v-if="!isInputer"
              outlined
              v-model="remark"
              label="Remarks"
              :error-messages="remarkErrors"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              small
              color="orange"
              dark
              :style="{ margin: '2px' }"
              @click="back"
            >
              <v-icon dark left> mdi-arrow-left </v-icon>
              Back
            </v-btn>
            <v-btn
              v-if="
                data != null &&
                data.status != 'sendback' &&
                !isHistory &&
                !isInputer
              "
              small
              color="success"
              :style="{ margin: '2px' }"
              @click="approveItem"
              :loading="loadingSave"
              :disabled="loadingSave"
            >
              Approve
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer"
              small
              color="error"
              dark
              :style="{ margin: '2px' }"
              @click="rejectItem"
            >
              Reject
            </v-btn>
            <v-btn
              v-if="!isHistory && !isInputer && !isDisabled && !isCPTS"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
              @click="sendbackItem"
            >
              Send Back
            </v-btn>
            <v-btn
              v-if="data != null && !isHistory && isInputer"
              @click="revisiItem"
              small
              color="warning"
              dark
              :style="{ margin: '2px' }"
            >
              Revisi
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to approve ?</v-card-title
        >

        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            :loading="loading"
            @click="approve"
          >
            Approve
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReject" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to reject ?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeReject">Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            :disabled="loading"
            :loading="loading"
            text
            @click="reject"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSendback" max-width="500px">
      <v-card>
        <v-card-title class="headline"
          >Are you sure you want to sendback ?</v-card-title
        >
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="closeSendback"
            >Cancel</v-btn
          >
          <v-btn
            color="blue darken-1"
            :disabled="loading"
            :loading="loading"
            text
            @click="sendback"
            >OK</v-btn
          >
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { text, date, showAlert } from '../../lib/helpers';

export default {
  components: {
    DataDetailRow: () => import('../../components/detail/DataDetailRow.vue'),
    RemarkRow: () => import('../../components/detail/RemarkRow.vue'),
    DtDetailOne: () => import('../../components/detail/DtDetailOne.vue'),
    DtDetailTwo: () => import('../../components/detail/DtDetailTwo.vue'),
    DtDetailThree: () => import('../../components/detail/DtDetailThree.vue'),
    DtDetailFour: () => import('../../components/detail/DtDetailFour.vue'),
  },
  mixins: [validationMixin],
  validations: {
    remark: {
      required,
    },
  },
  beforeMount() {
    this.getDetailData();
  },
  data() {
    return {
      merchant_type: 'Merchant',
      loadingSave: false,
      // qrisFile: null,
      dialog: false,
      dialogReject: false,
      dialogSendback: false,
      loading: false,
      remark: '',
      idTaskAdd: ['0', '2', '3'],
      idTaskEdit: ['4', '5', '6', '14'],
    };
  },
  computed: {
    data() {
      const { view } = this.$route.params;
      switch (view) {
        case 'approver-1-list':
          return this.$store.state.daftarTugas.mw.merchant;
        case 'inputer-list':
          return this.$store.state.daftarTugas.rm.merchant;
        case 'approver-2-list':
          return this.$store.state.daftarTugas.ho.merchant;
        case 'inputer-history-list':
          return this.$store.state.daftarTugas.rm.merchantHistory;
        case 'approver-1-history-list':
          return this.$store.state.daftarTugas.mw.merchantHistory;
        case 'approver-2-history-list':
          return this.$store.state.daftarTugas.ho.merchantHistory;
        default:
          return this.$store.state.daftarTugas.ho.merchant;
      }
    },
    isCPTS() {
      return this.data.id_qr_type == 8;
    },
    // loading() {
    //     return this.$store.state.daftarTugas.ho.loading;
    // },
    isHistory() {
      const { view } = this.$route.params;
      switch (view) {
        case 'approver-1-list':
          return false;
        case 'inputer-list':
          return false;
        case 'approver-2-list':
          return false;
        case 'inputer-history-list':
          return true;
        case 'approver-1-history-list':
          return true;
        case 'approver-2-history-list':
          return true;
        default:
          return false;
      }
    },

    isInputer() {
      const { view } = this.$route.params;
      switch (view) {
        case 'inputer-list':
          return true;
        case 'inputer-history-list':
          return true;
        default:
          return false;
      }
    },

    isDisabled() {
      const task = this.data.task_type_id;
      switch (task) {
        case 15:
          return true;
        case 7:
          return true;
        case 8:
          return true;
        case 9:
          return true;
        default:
          return false;
      }
    },

    isUpdatePTEN() {
      if (this.data != null) {
        if (this.data.task_type_id.toString() == '4') {
          return true;
        }
        if (this.data.task_type_id.toString() == '5') {
          return false;
        }
      }
      return false;
    },

    isAdd() {
      if (this.data != null) {
        if (this.idTaskAdd.includes(this.data.task_type_id.toString())) {
          return true;
        }
      }
      return false;
    },

    isEdit() {
      if (this.data != null) {
        if (this.idTaskEdit.includes(this.data.task_type_id.toString())) {
          return true;
        }
      }
      return false;
    },
    merchantTypeId() {
      if (this.data != null) {
        if (this.data.merchant_type_id != null) {
          return this.data.merchant_type_id;
        }
        return '1';
      }
      return '1';
    },
    remarkErrors() {
      const errors = [];
      if (!this.$v.remark.$dirty) {
        return errors;
      }
      if (!this.$v.remark.required) errors.push('Remark is required.');
      return errors;
    },
    headingInfo() {
      if (this.data == null) return '...';
      let dataVal = '';
      if (this.data.merchant_type_id == 2) {
        dataVal = 'Data Aggregator';
      } else {
        dataVal =
          this.data.merchant_type_id == 1
            ? 'Info Merchant'
            : 'Info Sub Merchant';
      }
      return dataVal;
    },
    merchantType() {
      let dataVal = '';
      if (this.data != null) {
        dataVal = this.data.merchant_type_id == 2 ? 'Aggregator' : 'Merchant';
      }
      return dataVal;
    },
    notifSticker() {
      try {
        return this.data == null
          ? ''
          : this.data.notif_sticker_status.toString();
      } catch {
        return '';
      }
    },
  },
  methods: {
    async getDetailData() {
      this.loading = true;
      const { view } = this.$route.params;

      switch (view) {
        case 'approver-1-list':
          await this.get('mw', view, 'viewMerchant');
          break;
        case 'inputer-list':
          await this.get('rm', view, 'viewMerchant');
          break;
        case 'approver-2-list':
          await this.get('ho', view, 'viewMerchant');
          break;
        case 'inputer-history-list':
          await this.get('rm', view, 'viewMerchantHistory');
          break;
        case 'approver-1-history-list':
          await this.get('mw', view, 'viewMerchantHistory');
          break;
        case 'approver-2-history-list':
          await this.get('ho', view, 'viewMerchantHistory');
          break;
        default:
          this.back();
          break;
      }
    },

    async get(store, route, view) {
      await this.$store
        .dispatch(`daftarTugas/${store}/${view}`, {
          id: this.$route.params.id,
          date,
        })
        .then(() => {
          if (this.data == null) {
            this.$router.push(`/daftar-tugas/${route}`);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
      });
    },
    closeReject() {
      this.dialogReject = false;
    },

    closeSendback() {
      this.dialogSendback = false;
    },

    approveItem() {
      this.dialog = true;
    },

    rejectItem() {
      this.dialogReject = true;
    },

    sendbackItem() {
      this.dialogSendback = true;
    },

    async approve() {
      this.loading = true;
      const { view } = this.$route.params;
      switch (view) {
        case 'approver-1-list':
          await this.setApprove('mw', view);
          break;
        case 'inputer-list':
          await this.setApprove('rm', view);
          break;
        case 'approver-2-list':
          await this.setApprove('ho', view);
          break;
        case 'inputer-history-list':
          await this.setApprove('rm', view);
          break;
        case 'approver-1-history-list':
          await this.setApprove('mw', view);
          break;
        case 'approver-2-history-list':
          await this.setApprove('ho', view);
          break;
        default:
          this.back();
          break;
      }
    },

    async setApprove(store, route) {
      await this.$store
        .dispatch(`daftarTugas/${store}/approve_reject`, {
          id: this.$route.params.id,
          remark: this.remark,
          date,
          category: 'approve',
        })
        .then((status) => {
          if (status) {
            showAlert(
              this.$store,
              'approve merchant success !',
              'mdi-check-circle',
              'green'
            );
            this.$router.push(`/daftar-tugas/${route}`);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async reject() {
      const { view } = this.$route.params;
      switch (view) {
        case 'approver-1-list':
          await this.setReject('mw', view);
          break;
        case 'inputer-list':
          await this.setReject('rm', view);
          break;
        case 'approver-2-list':
          await this.setReject('ho', view);
          break;
        case 'inputer-history-list':
          await this.setReject('rm', view);
          break;
        case 'approver-1-history-list':
          await this.setReject('mw', view);
          break;
        case 'approver-2-history-list':
          await this.setReject('ho', view);
          break;
        default:
          this.back();
          break;
      }
    },

    async setReject(store, route) {
      this.$v.remark.$touch();
      if (!this.$v.remark.$invalid) {
        this.loading = true;
        await this.$store
          .dispatch(`daftarTugas/${store}/approve_reject`, {
            id: this.$route.params.id,
            remark: this.remark,
            date,
            category: 'reject',
          })
          .then((status) => {
            if (status) {
              showAlert(
                this.$store,
                'reject merchant success !',
                'mdi-check-circle',
                'green'
              );
              this.$router.push(`/daftar-tugas/${route}`);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.closeReject();
      }
    },

    async sendback() {
      const { view } = this.$route.params;
      switch (view) {
        case 'approver-1-list':
          await this.setSendback('mw', view);
          break;
        case 'inputer-list':
          await this.setSendback('rm', view);
          break;
        case 'approver-2-list':
          await this.setSendback('ho', view);
          break;
        case 'inputer-history-list':
          await this.setSendback('rm', view);
          break;
        case 'approver-1-history-list':
          await this.setSendback('mw', view);
          break;
        case 'approver-2-history-list':
          await this.setSendback('ho', view);
          break;
        default:
          this.back();
          break;
      }
    },

    async setSendback(store, route) {
      this.$v.remark.$touch();
      if (!this.$v.remark.$invalid) {
        this.loading = true;
        await this.$store
          .dispatch(`daftarTugas/${store}/sendback`, {
            id: this.$route.params.id,
            date,
            remark: this.remark,
          })
          .then((status) => {
            if (status) {
              showAlert(
                this.$store,
                'send back success !',
                'mdi-check-circle',
                'green'
              );
              this.$router.push(`/daftar-tugas/${route}`);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.closeSendback();
      }
    },

    oldValue(variable) {
      if (
        this.data.old_value != null &&
        this.data.old_value[variable] != null &&
        this.data[variable] != this.data.old_value[variable]
      ) {
        return this.data.old_value[variable];
      }
      return false;
    },

    back() {
      this.$router.back();
    },

    registerMerchant() {
      this.$router.push({ path: '/client/merchant/register' });
    },

    revisiItem() {
      if (this.merchantType == 'Merchant') {
        this.$router.push(
          `/daftar-tugas/inputer-list/revisi-merchant/${this.$route.params.id}`
        );
      } else {
        this.$router.push(
          `/daftar-tugas/inputer-list/revisi-aggregator/${this.$route.params.id}`
        );
      }
    },

    text,
  },
};
</script>
